import React from "react";
import styled from "styled-components";
import { FiChevronRight } from "react-icons/fi";

const ViewAllCardContainer = styled.div`
  background-color: #fff;
  width: 19.25rem;
  height: 16rem;
  border-radius: 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  // padding: 100px;
`;

const ViewAllText = styled.div`
  color: #00a603;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  align-items: center;
  text-wrap: nowrap;
  word-break: keep-all;
`;

const ViewAllCard = ({ handleClick }: { handleClick: () => void }) => {
  return (
    <ViewAllCardContainer onClick={handleClick}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ViewAllText>View All</ViewAllText>
        <FiChevronRight size={24} color="#00a603" style={{ marginLeft: 10 }} />
      </div>
    </ViewAllCardContainer>
  );
};

export default ViewAllCard;
